import { Form } from "react-router-dom"
import { useActionData, useNavigation, Link, useRouteLoaderData } from 'react-router-dom';
import AdminTournamentsForm from '../../components/admin/AdminTournamentsForm.jsx'
import AdminTournamentsShow from '../../components/admin/AdminTournamentsShow.jsx'
import { GetTournament } from "../../repo/TournamentsRepo.js";
import { UpdateTournament } from "../../repo/TournamentsRepo.js";

export default function TournamentEditPage() {
  const responseSave = useActionData()
  const responseLoad = useRouteLoaderData('admin-tournament-edit')
  const createNavigation = useNavigation()
  const isSubmitting = createNavigation.state === 'submitting'

  return (
    <section className="m-8">
      {responseSave && responseSave.status && responseSave.status  ? (
        <AdminTournamentsShow tournament={responseSave.data} status="updated"/>
      ) : (
        <>
          <h1>Edit Tournament</h1>
          <div id="tournament-create-form" className={`w-full py-4 mb-4'`}>
            <Form method="PUT" className="space-y-4 md:space-y-6 mt-4">
              <AdminTournamentsForm tournament={responseLoad} errors={(responseSave && responseSave.errors) ? responseSave.errors : null } isSubmitting={isSubmitting}/>
            </Form>
          </div>

          <div id="tournaments" className={`w-full pt-4 mt-4'`}>
            <Link className="hover:no-underline underline" to="/cocofantoelefanto/tournaments">Back to Tournaments</Link>
          </div>
        </>
      )}
    </section>
  )
}

export async function action({request}) {
  const data = await request.formData()

  const tournament = {
    name: data.get('name'),
    edition: data.get('edition'),
    starts_at: data.get('starts_at'),
    ends_at: data.get('ends_at'),
    third_party_label: data.get('third_party_label'),
    third_party_id: data.get('third_party_id'),
    third_party_season: data.get('third_party_season'),
    tournament_standings: {
      rules: data.get('tournament_standings_rules'),
      content: data.get('tournament_standings_content'),
    }
  }

  return await UpdateTournament(data.get('id'), tournament)
}

export async function loader({ params, request }) {
  return await GetTournament(params.id)
}
